import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { firebaseAnalytics } from "../services/firebase.";

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (firebaseAnalytics && import.meta.env.VITE_APP_ENV === "production") {
      logEvent(firebaseAnalytics, "page_view", {
        page_title: location.pathname,
        // page_location: window.location.href,
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
};

export default AnalyticsTracker;
